import { LAYER, POPUP_IDS } from 'js/components/common/PopupManager';
import { showCommonPopupAction } from 'js/components/common/popups/CommonPopup';
import { showConfirmationPopupAction } from 'js/components/common/popups/ConfirmationPopup';

export const showLogoutNotificationPopupAction = ({
    isLoginAgainPopup,
    onAccept,
    onDecline = undefined,
    className = 'logout-notification-popup'
}) =>
    isLoginAgainPopup
        ? showConfirmationPopupAction({
            onAccept,
            onDecline,
            className,
            id: POPUP_IDS.LOGOUT_NOTIFICATION_POPUP,
            layer: LAYER.HIGH_PRIORITY,
            closeAll: true,
            isModal: false,
            title: 'playtech.mobile.system.logout.title',
            content: 'playtech.mobile.system.logout.message',
            acceptBtnText: 'playtech.mobile.system.loginagain.button.title',
            declineBtnText: 'playtech.mobile.system.ok.button.title'
        })
        : showCommonPopupAction({
            className,
            id: POPUP_IDS.LOGOUT_NOTIFICATION_POPUP,
            layer: LAYER.HIGH_PRIORITY,
            closeAll: true,
            title: 'playtech.mobile.system.logout.title',
            content: 'playtech.mobile.system.logout.message'
        });
